import { useContext, useMemo } from 'react';
import { SplitioContext, SplitioFeature } from 'components/SplitioContext';

const useEnableHotjarTreatment = () => {
  const { isReady, isTreatmentOn } = useContext(SplitioContext);

  return useMemo(
    () => isReady && isTreatmentOn(SplitioFeature.enableHotjar),
    [isReady, isTreatmentOn],
  );
};

export default useEnableHotjarTreatment;
